import store from 'store';

// NOTE: Configuration from environment variables is deprecated.
// Pass configuration as props instead.

// TODO: figure out if any consumers are still passing in quizzes_vars - (don't think so)
var quizzesVars = process.quizzes_vars || process.env || {};
export var environment = {
  nodeEnv: quizzesVars.NODE_ENV || 'development'
};
environment.inDevelopment = function () {
  return environment.nodeEnv === 'development';
};
var langParam = window.location.search.match(/[&?]lang=([^&]*)/);
environment.lang = langParam && langParam[1] || store.enabled && store.get('lang') || void 0;
if (store.enabled) {
  store.set('lang', environment.lang);
}

/* eslint-disable no-undef */
if (typeof NODE_ENV !== 'undefined' && (NODE_ENV === 'development' || NODE_ENV === 'test')) {
  if (typeof CONFIG !== 'undefined') {
    Object.assign(environment, CONFIG);
  }
  window.ENV = environment;
}
/* eslint-enable no-undef */

export default environment;